export const NAMESPACE = "PortalSessionFileContentFlyOver";
export const EDIT_TYPE_FORM_ID = "EditTypeFormId";
export const FILE_TYPES = [
  { id: "presentation", label: "Presentation" },
  { id: "poster", label: "Poster" },
  { id: "handout", label: "Handout" }
];

export const MEASURE = 1000;

export const MAX_FILE_SIZE_GB = 1.95;
export const MAX_FILE_SIZE_MB = MAX_FILE_SIZE_GB * MEASURE; // 1.95 GB to MB
export const MAX_FILE_SIZE_KB = MAX_FILE_SIZE_MB * MEASURE; // MB to KB

export const MIN_FILE_SIZE_GB = 0;
export const MIN_FILE_SIZE_MB = MIN_FILE_SIZE_GB * MEASURE;
export const MIN_FILE_SIZE_KB = MIN_FILE_SIZE_MB * MEASURE;

export const VIEW_TYPES = {
  LIST: "list",
  FILE: "file"
};
